import { createSelector } from 'reselect'
import constants from 'common/helpers/constants'


type Product = {
  type: string
}

const isOnlyPerfumeCasesInCartSelector = (products: [Product]) => createSelector(
  (state: any): Array<Product> => Object.values(state.models.cart.items.products.items),
  (state: any): boolean => state.models.subscription.isActive,
  (state: any): boolean => state.models.subscription.isMonthlyPlan,
  (cartitems: [Product], isActive: boolean, isMonthlyPlan: boolean): boolean => {
    const items = products || cartitems

    const isOnlyPerfumeCase = Boolean(items.length) && items.every(
      (product: Product): boolean => (
        Boolean(product) && product.type === constants.productTypeGroups.perfumeCase
      )
    )

    return isOnlyPerfumeCase && isActive && isMonthlyPlan
  }
)

export default isOnlyPerfumeCasesInCartSelector
